import React, { useContext, useEffect } from "react";
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
import { ASSET_IMAGES } from "../../utils/constants/paths";
import { CustomProvider } from "app/layouts/vertical-default/VerticalDefault";
import ChangeFavIcon from "../../pages/dashboard/Crypto/ChangeFavIcon";

const Logo = ({ mini, mode, sx }) => {
  const { loginUserData, wlApps } = useContext(CustomProvider);
  const wl_admin_domains = ["echtjetztki"]
  const logos = [{ "domain": "echtjetztki", "logo": "https://novalya-assets.s3.us-east-1.amazonaws.com/assets/profile-picture/babylala.png", title: "Echtjetztki Admin" }]
  const path = window.location.pathname.toLowerCase();

  const is_wl = wlApps?.find((item) => window.location.href.includes(item)) || false

  const wl_logo = {
    "akquise": "https://novalya-assets.s3.us-east-1.amazonaws.com/assets/profile-picture/babylala.png",
    "xyz": "https://xyz.novalya.com/assets/images/logo.png",
    "echtjetztki": "https://novalya-assets.s3.us-east-1.amazonaws.com/assets/profile-picture/babylala.png"
  }

  useEffect(() => {
    const currentUrl = window.location.href.toLowerCase();
    const isWhitelisted = wl_admin_domains.find(domain =>
      currentUrl.includes(domain.toLowerCase()) || ""
    );
    console.log(isWhitelisted, "isWhitelisted")
    if (isWhitelisted) {
      const data = logos.find(item => item.domain === isWhitelisted);

      let link = document.querySelector("link[rel~='icon']");

      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      document.title = data?.title;
      link.href = data?.logo;
    }
  }, [path])
  return (
    <Div
      sx={{
        marginLeft: "25px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...sx,
      }}
    >
      <Link href={"/dashboard"}>


        {
          is_wl ?
            <img
              className="logo"
              src={
                wl_logo[is_wl]
              }
              style={{ width: "80px", height: "80px" }}
              alt="Novalya"
            /> :

            (loginUserData && loginUserData.usertype === "reseller") ||
              (loginUserData.usertype === "admin" && loginUserData.parent_id > 0) ? (
              <img
                src={
                  mode === "light"
                    ? loginUserData.profilepictureurl
                    : loginUserData.profilepictureurl
                }
                style={{ width: "80px" }}
                alt="Novalya"
              />
            ) : !mini ? (
              <img
                className="logo"
                src={
                  mode === "light"
                    ? `${ASSET_IMAGES}/logo.png`
                    : `${ASSET_IMAGES}/logo-white.png`
                }
                style={{ width: "80px" }}
                alt="Novalya"
              />
            ) : (
              <img
                src={
                  mode === "dark"
                    ? `${ASSET_IMAGES}/logo-short.png`
                    : `${ASSET_IMAGES}/logo-short-white.png`
                }
                style={{ width: "80px" }}
                alt="Novalya"
              />
            )}
      </Link>
      {!is_wl && <ChangeFavIcon />}
    </Div>
  );
};

Logo.defaultProps = {
  mode: "light",
};

export default Logo;
